import IconBase from '../../utils/IconBase';
import { IconProps } from '../../utils/icon';

const BinLine = ({ width = 18, height = 18, ...props }: IconProps) => {
  return (
    <IconBase
      width={width}
      height={height}
      {...props}
      paths={[
        {
          d: 'M5.85581 15.3743C5.48294 15.3743 5.16375 15.2416 4.89825 14.9761C4.63275 14.7106 4.5 14.3914 4.5 14.0185V4.49931H3.9375C3.77812 4.49931 3.64456 4.44538 3.53681 4.3375C3.42894 4.22962 3.375 4.096 3.375 3.93663C3.375 3.77712 3.42894 3.64356 3.53681 3.53594C3.64456 3.42819 3.77812 3.37431 3.9375 3.37431H6.75C6.75 3.19069 6.81469 3.03419 6.94406 2.90481C7.07331 2.77556 7.22975 2.71094 7.41337 2.71094H10.5866C10.7703 2.71094 10.9267 2.77556 11.0559 2.90481C11.1853 3.03419 11.25 3.19069 11.25 3.37431H14.0625C14.2219 3.37431 14.3554 3.42825 14.4632 3.53613C14.5711 3.644 14.625 3.77763 14.625 3.937C14.625 4.0965 14.5711 4.23006 14.4632 4.33769C14.3554 4.44544 14.2219 4.49931 14.0625 4.49931H13.5649V14.0185C13.5649 14.3914 13.4321 14.7106 13.1666 14.9761C12.9011 15.2416 12.5819 15.3743 12.2091 15.3743H5.85581ZM12.4399 4.49931H5.625V14.0185C5.625 14.0859 5.64663 14.1412 5.68987 14.1844C5.73312 14.2277 5.78844 14.2493 5.85581 14.2493H12.2091C12.2764 14.2493 12.3317 14.2277 12.375 14.1844C12.4183 14.1412 12.4399 14.0859 12.4399 14.0185V4.49931Z',
          fill: props.fill || '#4C5053',
        },
      ]}
    />
  );
};

export default BinLine;
